import { Stack, Typography } from '@mui/material';
import PageHeaderBreadcrumbs from './PageHeaderBreadcrumbs';

export interface PageHeaderProps {
  title?: string;
  breadcrumbsCurrentPage?: string;
  showBreadcrumbs?: boolean;
  metadata?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  breadcrumbsCurrentPage,
  showBreadcrumbs = false,
  metadata,
}) => {
  if (!title && !showBreadcrumbs && !metadata) return null;

  return (
    <Stack direction="column" gap={1}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        {showBreadcrumbs ? <PageHeaderBreadcrumbs title={title} currentPage={breadcrumbsCurrentPage} /> : null}
        {metadata ? (
          <Typography variant="body2" color="textSecondary" sx={{ whiteSpace: 'pre-line', textAlign: 'right' }}>
            {metadata}
          </Typography>
        ) : null}
      </Stack>
      {title ? (
        <Typography variant="h1" color="brand" mb={1}>
          {title}
        </Typography>
      ) : null}
    </Stack>
  );
};

export default PageHeader;
